import {
  ExternalSearchAwaitingDispatch,
  ExternalSearchBooked,
  ExternalSearchDelivered,
  ExternalSearchInTransit
} from '../../../lib/consts/ListyConsts';
import { GetDatesForPeriod } from '../../dash/GetDatesForPeriod';
import {
  PickingListDaily,
  PickingListSearch,
  PickingListSearchExcludeDispatched,
  PickingListSearchExcludePackaged,
  PickingListSearchExcludePackagedAndDispatched
} from '../../warehouse/pickinglist/PickingConstants';

export function getExternalSearchQueryParamsAndAppendSource(period: string, searchType: string, sources: string[]) {
  let output = getExternalSearchQueryParams(period, searchType);
  if (sources?.length > 0) {
    output += ` AND (${sources.map((x) => `('smartSend.sources':'${x}')`).join(' OR ')})`;
  }
  return output;
}

export function getExternalSearchQueryParamsMarketplaceCount(period: string, searchType: string) {
  return getExternalSearchQueryParams(period, searchType) + " AND ('smartSend.count' > 0)";
}

export function appendTenantFilterToQueryParams(queryParams: string, tenant: string) {
  const tenantFilter = `tenant:'${tenant}'`;

  if (queryParams?.includes(tenantFilter)) {
    return queryParams;
  }

  return queryParams ? `${queryParams} AND (${tenantFilter})` : tenantFilter;
}

export default function getExternalSearchQueryParams(period: string, searchType: string) {
  const dates = GetDatesForPeriod(period);
  switch (searchType) {
    case ExternalSearchInTransit:
      return `(paidDate:${dates.fromUnix} TO ${dates.toUnix}) AND (NOT trackingStatus:'New') AND (NOT trackingStatus:'Delivered')`;

    case ExternalSearchDelivered:
      return `(paidDate:${dates.fromUnix} TO ${dates.toUnix}) AND (trackingStatus:'Delivered')`;

    case ExternalSearchBooked:
      return `(paidDate:${dates.fromUnix} TO ${dates.toUnix})`;

    case ExternalSearchAwaitingDispatch:
      return `(paidDate:${dates.fromUnix} TO ${dates.toUnix}) AND (NOT actionTags:'DISPATCHED') AND ('smartSend.count' > 0) AND (NOT 'smartSend.sources':'Manual') AND (NOT 'smartSend.sources':'CSV')`;

    case PickingListSearchExcludeDispatched:
      return `(paidDate:${dates.fromUnix} TO ${dates.toUnix}) AND (NOT actionTags:'DISPATCHED') AND (NOT trackingStatus:'Delivered') AND (parcelCount > 0)`;

    case PickingListSearchExcludePackaged:
      return `(paidDate:${dates.fromUnix} TO ${dates.toUnix}) AND (NOT actionTags:'PACKAGED') AND (NOT trackingStatus:'Delivered') AND (parcelCount > 0)`;

    case PickingListSearchExcludePackagedAndDispatched:
      return `(paidDate:${dates.fromUnix} TO ${dates.toUnix}) AND (NOT actionTags:'DISPATCHED') AND (NOT actionTags:'PACKAGED') AND (NOT trackingStatus:'Delivered') AND (parcelCount > 0)`;

    case PickingListDaily:
      return `(paidDate:${dates.fromUnix} TO ${dates.toUnix}) AND (NOT trackingStatus:'Delivered') AND (parcelCount > 0)`;

    case PickingListSearch:
      return `(paidDate:${dates.fromUnix} TO ${dates.toUnix}) AND (NOT trackingStatus:'Delivered') AND (parcelCount > 0)`;

    default:
      return `(paidDate:${dates.fromUnix} TO ${dates.toUnix})`;
  }
}
